import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import Yihao from '../views/Yihao.vue'
import Yiting from '../views/Yiting.vue'
import Jiayue from '../views/Jiayue.vue'
import Jyjingxuan from '../views/Jyjingxuan.vue'
import Wendu from '../views/Wendu.vue'
import Jingsu from '../views/Jingsu.vue'
import Hemei from "../views/Hemei.vue";
import Junlan from '../views/Junlan.vue';
import Duobaan from '../views/Duobaan.vue';
import Jiayi from "../views/Jiayi.vue";
import Qingju from '../views/Qingju.vue';
import Join from '../views/Join.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/Yiting',
    name: 'Yiting',
    component: Yiting
  },
  {
    path: '/Yihao',
    name: 'Yihao',
    component: Yihao
  },
  {
    path: '/Jiayue',
    name: 'Jiayue',
    component: Jiayue
  },
  {
    path: '/Jyjingxuan',
    name: 'Jyjingxuan',
    component: Jyjingxuan
  },
  {
    path: '/Wendu',
    name: 'Wendu',
    component: Wendu
  },
  {
    path: '/Jingsu',
    name: 'Jingsu',
    component: Jingsu
  },
  {
    path: '/Hemei',
    name: 'Hemei',
    component: Hemei
  },
  {
    path: '/Junlan',
    name: 'Junlan',
    component: Junlan
  },
  {
    path: '/Duobaan',
    name: 'Duobaan',
    component: Duobaan
  },
  {
    path: '/Jiayi',
    name: 'Jiayi',
    component: Jiayi
  },
  {
    path: '/Qingju',
    name: 'Qingju',
    component: Qingju
  },
  {
    path: '/Join',
    name: 'Join',
    component: Join
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  next();
});
export default router
